import { Component, Input } from '@angular/core';
import { getProvider } from '../../../../Common/Forms/models/control-value-accessor.model';
import { TextInputChipsComponent } from '../../../../Common/Forms/components/TextInputChips/text-input-chips.component';
import { BlacklistedHandle, BlacklistReasonEnum } from '../../../../api/mediaSubscriptions/models/media-subscription.api.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

export interface HandlesChipsModel {
    handle: string;
    valid: boolean;
    reason?: BlacklistReasonEnum;
}

@Component({
    selector: 'agpr-handles-text-input-chips',
    styleUrls: [ './handles-text-input-chips.component.scss' ],
    templateUrl: './handles-text-input-chips.component.html',
    standalone: false,
    providers: [ getProvider(HandlesTextInputChipsComponent) ]
})
export class HandlesTextInputChipsComponent extends TextInputChipsComponent {
    @Input() set invalidHandles(handles: BlacklistedHandle[]) {
        this._invalidHandles = handles;
        this.makeChips();
    }
    @Input() caseSensitive: boolean = false;

    chips: HandlesChipsModel[];
    _invalidHandles: BlacklistedHandle[];

    readonly buttonTypes = ButtonTypesEnum;

    writeValue(value: string[]): void {
        super.writeValue(value);
        this.makeChips();
    }

    addChip(chip: string) {
        super.addChip(chip);
        this.makeChips();
    }

    makeChips() {
        this.chips = [];
        if (this.value.length > 0) {
            this.value.forEach(handle => {
                this.chips.push({
                    handle: handle,
                    valid: true
                });
            });
            if (this._invalidHandles?.length > 0) {
                this._invalidHandles.forEach(invalidHandle => {
                    const handle = invalidHandle.handle;
                    const invalidChip = this.chips.find(chip => {
                        const chipHandle = this.caseSensitive ? chip.handle : chip.handle.toLowerCase();
                        if (chip.handle.startsWith('@')) {
                            return handle === chipHandle.slice(1);
                        } else if (chip.handle.startsWith('r/') || chip.handle.startsWith('u/')) {
                            return handle ===  chipHandle.slice(2);
                        } else {
                            return handle === chipHandle;
                        }
                    });
                    if (!!invalidChip) {
                        invalidChip.valid = false;
                        invalidChip.reason = invalidHandle.reason;
                    }
                });
            }
        }
    }

    removeChip(chip: any): void {
        const index = this.value.indexOf(chip.handle);
        if (index >= 0) {
            this.value.splice(index, 1);
            this.chips.splice(index, 1);
        }

        this.onModelChange(this.value);
    }

    removeAllChips(): void {
        this.value = [];
        this.chips = [];
        this.onModelChange(this.value);
    }
}
